function WhatsAppText(text) {
  text = text.replace(/\s+/g, '%20')
  return 'https://wa.me//555136635264?text=' + text
}

export default WhatsAppText
